import { useRates } from '../hooks/use-rates';

export function RatesTable() {
  const { data: rates, isLoading, error } = useRates();

  if (isLoading) return <div>Loading rates...</div>;
  if (error) return <div>Error loading rates</div>;

  return (
    <div className="overflow-hidden rounded-lg border bg-white shadow">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Name
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Value
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Currency
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Updated
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {rates?.map((rate) => (
            <tr key={rate.id}>
              <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                {rate.name}
              </td>
              <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{rate.value}</td>
              <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">{rate.currency}</td>
              <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                {new Date(rate.updatedAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
